import { Icon } from '@blueprintjs/core'
import React from 'react'
import toast from 'react-hot-toast'
import { v4 as uuid } from 'uuid'

export const Toasts = {
    success: (message: string | JSX.Element): string => {
        const msg = (
            <div className="flex justify-between w-80">
                {message}{' '}
                <span className="pr-3 cursor-pointer" onClick={removeToaster}>
                    <Icon icon={'cross'} />
                </span>
            </div>
        )

        return toast(msg, {
            duration: 4000,
            position: 'top-right',

            // Styling
            style: {
                padding: '8px',
                color: '#fff',
                background: '#24B89E',
            },

            // Change colors of success/error/loading icon
            iconTheme: {
                primary: '#fff',
                secondary: '#fff',
            },

            icon: <Icon className="pl-1" icon={'tick'} />,

            // Aria
            ariaProps: {
                role: 'status',
                'aria-live': 'polite',
            },
        })
    },

    error: (message: string | JSX.Element, id: string = ''): string => {
        const msg = (
            <div className="flex justify-between w-80">
                {message}{' '}
                <span className="pr-3 cursor-pointer" onClick={removeToaster}>
                    <Icon icon={'cross'} />
                </span>
            </div>
        )

        if (id == '') {
            id = uuid()
        }

        return toast(msg, {
            duration: 4000,
            position: 'top-right',
            id,

            // Styling
            style: {
                padding: '8px',
                color: '#fff',
                background: '#CC2929',
            },

            // Change colors of success/error/loading icon
            iconTheme: {
                primary: '#fff',
                secondary: '#fff',
            },

            icon: <Icon className="pl-1" icon={'warning-sign'} />,

            // Aria
            ariaProps: {
                role: 'status',
                'aria-live': 'polite',
            },
        })
    },

    primary: (message: string | JSX.Element): string => {
        const msg = (
            <div className="flex justify-between w-80">
                {message}{' '}
                <span className="pr-3 cursor-pointer" onClick={removeToaster}>
                    <Icon icon={'cross'} />
                </span>
            </div>
        )

        return toast(msg, {
            duration: 4000,
            position: 'top-right',

            // Styling
            style: {
                padding: '8px',
                color: '#fff',
                background: '#2974CC',
            },

            // Change colors of success/error/loading icon
            iconTheme: {
                primary: '#fff',
                secondary: '#fff',
            },

            icon: <Icon className="pl-1" icon={'info-sign'} />,

            // Aria
            ariaProps: {
                role: 'status',
                'aria-live': 'polite',
            },
        })
    },

    warning: (message: string | JSX.Element): string => {
        const msg = (
            <div className="flex justify-between w-80">
                {message}{' '}
                <span className="pr-3 cursor-pointer" onClick={removeToaster}>
                    <Icon icon={'cross'} />
                </span>
            </div>
        )

        return toast(msg, {
            duration: 4000,
            position: 'top-right',

            // Styling
            style: {
                padding: '8px',
                color: '#fff',
                background: '#FF9533',
            },

            // Change colors of success/error/loading icon
            iconTheme: {
                primary: '#fff',
                secondary: '#fff',
            },

            icon: <Icon className="pl-1" icon={'warning-sign'} />,

            // Aria
            ariaProps: {
                role: 'status',
                'aria-live': 'polite',
            },
        })
    },
}

const removeToaster = () => {
    toast.dismiss()
}
